<template>
  <div class="tw-text-base tw-text-infinity-secondary-text tw-border-b sm:tw-border-b-0 md:tw-border-b tw-border-solid tw-border-opacity-20 tw-border-infinity-border tw-border-0">
    <span v-if="shownText.length">{{ shownText }}</span>
    <span v-else class="tw-italic tw-text-infinity-tertiary-text">— No description</span>
    <span v-if="hasMore">
      <span v-if="!showAll">...</span>
      <span class="tw-underline tw-text-infinity-primary-text tw-cursor-pointer" @click="showAll = !showAll">{{ !showAll ? 'more' : 'less' }}</span>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    maxLength: {
      type: Number,
      default: 119
    }
  },
  data() {
    return {
      showAll: false
    }
  },
  computed: {
    shownText() {
      return this.showAll ? this.text : this.text.substring(0, this.maxLength)
    },
    hasMore() {
      return this.text.length > this.maxLength
    }
  }
}
</script>
